// extracted by mini-css-extract-plugin
export default {"widget":"BlockSwitcher_widget__5ToXq","item":"BlockSwitcher_item__Q2KYR","active":"BlockSwitcher_active__Ue2k6"};